import React from 'react'
import { useTranslation } from 'react-i18next'

const T = 'natura_operations.notfis_upload'

// The file is always stored by the time this renders, so the panel reports
// whether it reached an order — not whether the upload worked.
const STYLES = {
  applied: 'border-green-200 bg-green-50 text-green-900',
  order_not_found: 'border-red-200 bg-red-50 text-red-800',
  not_applied: 'border-amber-200 bg-amber-50 text-amber-800',
  processing_error: 'border-amber-200 bg-amber-50 text-amber-800',
}

export default function ResultPanel({ result }) {
  const { t } = useTranslation()
  if (!result) return null

  const { outcome, file_name, compressed, order, message } = result
  const style = STYLES[outcome] || STYLES.not_applied

  return (
    <div className={`mt-6 p-4 border rounded text-sm ${style}`}>
      <p className="font-semibold">{t(`${T}.outcome_${outcome}`, { order_number: order?.order_number })}</p>

      <p className="mt-2">
        {t(`${T}.result_label_file`)}: <strong>{file_name}</strong>
        {compressed && <span className="ml-1">({t(`${T}.result_compressed`)})</span>}
      </p>

      {order && (
        <p className="mt-1">
          {t(`${T}.result_label_layout`)}: <strong>{t(`${T}.layout_${order.layout}`)}</strong>
        </p>
      )}

      {message && <p className="mt-2 font-mono text-xs break-all">{message}</p>}

      <p className="mt-3">{t(`${T}.next_${outcome}`)}</p>
    </div>
  )
}
